import { createCollection } from '@rocketlane/state-db';
import { TimesheetAPI } from 'api/timesheets';
/**
 * Single source of truth for individual time entries (`ApiTimesheetEntry`).
 *
 * Replaces scattered React Query caches (`useGetTimeEntryById`, inline
 * `queryClient.setQueryData` calls) and the AG Grid row-node patching in
 * `use-timesheets-list-socket.ts`. Data enters via `push()` from:
 *   - Week-view fetches (`TimesheetAPI.getTimesheetForUser`)
 *   - Timesheets-list AG Grid datasource (`TimesheetsListApi.getPaginatedTimeEntriesList`)
 *   - WS refetches (`TimesheetAPI.getTimeEntriesByIds`)
 *   - Write responses (add, update, bulk operations)
 *
 * `onUpdate` routes to `TimesheetAPI.updateTimeEntry`; `onInsert` routes to
 * `addTimeEntry`; `onDelete` routes to `deleteTimeEntry`. The complex routing
 * for bulk operations (`bulkEditTimeEntries`, `deleteTimesheetTask`) is wired
 * in Wave 3 via `actions.ts`.
 */ const routeUpdate = async (ctx)=>{
    var _ctx_changes;
    return TimesheetAPI.updateTimeEntry(Number(ctx.id), (_ctx_changes = ctx.changes) !== null && _ctx_changes !== void 0 ? _ctx_changes : {});
};
const routeDelete = async (ctx)=>{
    await TimesheetAPI.deleteTimeEntry(Number(ctx.id));
};
export const timeEntryCollection = createCollection({
    id: 'time-entries',
    getKey: (entry)=>entry.timeEntryId,
    indexes: {
        byUser: (entry)=>entry.userId
    },
    // No monotonic version on the bean — always-replace on push.
    // The WS generation guard lives in the fetcher (`fetchTimeEntriesByIds`)
    // to prevent a stale batch refetch from overwriting a newer optimistic edit.
    isNewer: ()=>true,
    onUpdate: routeUpdate,
    onDelete: routeDelete
});
/** Imperative read of one entry from the collection. */ export const getTimeEntryFromCollection = (timeEntryId)=>timeEntryCollection.get(timeEntryId);
/** Imperative read of all entries for a user. */ export const getTimeEntriesForUserFromCollection = (userId)=>timeEntryCollection.getByIndex('byUser', userId);
